import "./globals/appsignal";
import "phoenix_html";

import "./globals";
import "./components";

import { initAnalytics } from "./services/analytics";

document.addEventListener("DOMContentLoaded", () => {
  initAnalytics();
});

// In case the dom was already loaded
initAnalytics();
